document.addEventListener("DOMContentLoaded", function () {
  initProductSectionReveals();
  initSpiritGalleries();
});

function initProductSectionReveals() {
  /* 01/08/2026 — les anciens sélecteurs .sb-maison-* (hero__intro, buttons,
     choice__box, two-paths, dark-card, vision__inner…) dataient d'une
     itération WordPress abandonnée de la page Maison : la page construite
     dans le thème (sections sifi-maison-*) porte directement ses classes de
     reveal ET ses délais inline dans le liquid — plus rien à ajouter ici.
     Les définitions CSS (réglage v16) vivent dans maison.css. */
  const revealSelectors = [
    /* Page Maison */
    ".sb-maison-title-reveal",
    ".sb-maison-media-reveal",

    /* Page produit Great White */
    ".sb-gw-reveal",
    ".sb-gw-title-reveal",
    ".sb-gw-feature-media-reveal"
  ];

  const elements = Array.from(
    document.querySelectorAll(revealSelectors.join(","))
  ).filter(function (el) {
    return !el.closest("[data-sb-gw-spirit-gallery]");
  });

  if (!elements.length) return;

  if (!("IntersectionObserver" in window)) {
    elements.forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.16,
      rootMargin: "0px 0px -8% 0px"
    }
  );

  elements.forEach(function (el) {
    observer.observe(el);
  });
}

function initSpiritGalleries() {
  const galleries = document.querySelectorAll("[data-sb-gw-spirit-gallery]");
  const reducedMotion = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;

  galleries.forEach(function (gallery) {
    const track = gallery.querySelector("[data-sb-gw-spirit-track]");
    const segments = Array.from(
      gallery.querySelectorAll("[data-sb-gw-spirit-progress]")
    );
    const previousButton = gallery.querySelector(
      "[data-sb-gw-spirit-previous]"
    );
    const nextButton = gallery.querySelector(
      "[data-sb-gw-spirit-next]"
    );

    if (!track) return;

    let activeIndex = 0;
    let scrollFrame = null;
    let loopTimer = null;
    let desktopLoopReady = false;

    function getRealItems() {
      return Array.from(
        track.querySelectorAll(
          "[data-sb-gw-spirit-item]:not([data-sb-gw-spirit-clone])"
        )
      );
    }

    function getAllItems() {
      return Array.from(
        track.querySelectorAll("[data-sb-gw-spirit-item]")
      );
    }

    function normalizeRealItems() {
      getRealItems().forEach(function (item, index) {
        item.classList.remove(
          "sb-gw-reveal",
          "sb-gw-reveal--left",
          "sb-gw-reveal--right",
          "sb-gw-reveal--soft",
          "sb-gw-delay-1",
          "sb-gw-delay-2",
          "sb-gw-delay-3",
          "is-visible"
        );

        item.classList.add("sb-gw-spirit-image-reveal");
        item.setAttribute("data-sb-gw-spirit-image-reveal", "");
        item.setAttribute(
          "data-sb-gw-spirit-reveal-index",
          String(index)
        );
        item.style.setProperty(
          "--sb-gw-spirit-image-reveal-delay",
          String(160 + (index * 110)) + "ms"
        );

        item.classList.toggle(
          "sb-gw-spirit-image-reveal--mobile-static",
          index > 1
        );
      });
    }

    function isDesktopLoop() {
      return (
        gallery.classList.contains("sb-gw-spirit-gallery--carousel") &&
        window.matchMedia("(min-width: 641px)").matches
      );
    }

    function getTrackInset() {
      const styles = window.getComputedStyle(track);
      const paddingLeft = parseFloat(styles.paddingLeft);

      return Number.isFinite(paddingLeft) ? paddingLeft : 0;
    }

    function getTrackGap() {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap);

      return Number.isFinite(gap) ? gap : 0;
    }

    function getMaximumScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function setTrackScrollInstant(left) {
      const previousBehavior = track.style.getPropertyValue("scroll-behavior");
      const previousPriority = track.style.getPropertyPriority("scroll-behavior");

      track.style.setProperty("scroll-behavior", "auto", "important");
      track.scrollLeft = left;
      track.getBoundingClientRect();

      if (previousBehavior) {
        track.style.setProperty(
          "scroll-behavior",
          previousBehavior,
          previousPriority
        );
      } else {
        track.style.removeProperty("scroll-behavior");
      }
    }

    function getPairScroll(leftItem) {
      const pairWidth =
        (leftItem.offsetWidth * 2) +
        getTrackGap();

      const sideSpace =
        (track.clientWidth - pairWidth) / 2;

      const requested =
        leftItem.offsetLeft -
        sideSpace;

      return Math.min(
        getMaximumScroll(),
        Math.max(0, requested)
      );
    }

    function getMobileScroll(item) {
      const requested =
        item.offsetLeft -
        getTrackInset();

      return Math.min(
        getMaximumScroll(),
        Math.max(0, requested)
      );
    }

    function updateSegments(index) {
      const realCount = getRealItems().length;

      if (realCount === 0) return;

      activeIndex =
        ((index % realCount) + realCount) % realCount;

      segments.forEach(function (segment, segmentIndex) {
        const active = segmentIndex === activeIndex;

        segment.classList.toggle("is-active", active);

        if (active) {
          segment.setAttribute("aria-current", "true");
        } else {
          segment.removeAttribute("aria-current");
        }
      });
    }

    function removeClones() {
      track
        .querySelectorAll("[data-sb-gw-spirit-clone]")
        .forEach(function (clone) {
          clone.remove();
        });

      desktopLoopReady = false;
    }

    function prepareClone(item, position) {
      const clone = item.cloneNode(true);

      clone.setAttribute("data-sb-gw-spirit-clone", position);

      clone.classList.remove(
        "sb-gw-reveal",
        "sb-gw-reveal--left",
        "sb-gw-reveal--right",
        "sb-gw-reveal--soft",
        "sb-gw-delay-1",
        "sb-gw-delay-2",
        "sb-gw-delay-3",
        "sb-gw-spirit-image-reveal--mobile-static",
        "is-visible"
      );

      clone.removeAttribute("data-sb-gw-spirit-image-reveal");
      clone.removeAttribute("data-sb-gw-spirit-reveal-index");
      clone.style.removeProperty("--sb-gw-spirit-image-reveal-delay");

      /* Le clone apparaît avec les autres images : masqué tant que la
         galerie n'est pas révélée, visible une fois révélée (ou tout de
         suite si elle l'a déjà été, ex. redimensionnement). */
      if (
        gallery.dataset.sbSpiritRevealed === "1" ||
        (reducedMotion && reducedMotion.matches)
      ) {
        clone.classList.add("is-visible");
      }

      return clone;
    }

    function createClones() {
      removeClones();

      const realItems = getRealItems();

      if (!isDesktopLoop() || realItems.length <= 3) return;

      const realCount = realItems.length;

      const beforeSecondLast = prepareClone(
        realItems[realCount - 2],
        "before-second-last"
      );
      const beforeLast = prepareClone(
        realItems[realCount - 1],
        "before-last"
      );

      const afterFirst = prepareClone(
        realItems[0],
        "after-first"
      );
      const afterSecond = prepareClone(
        realItems[1],
        "after-second"
      );
      const afterThird = prepareClone(
        realItems[2],
        "after-third"
      );

      const beforeFragment = document.createDocumentFragment();
      beforeFragment.append(beforeSecondLast, beforeLast);
      track.prepend(beforeFragment);

      track.append(afterFirst, afterSecond, afterThird);

      desktopLoopReady = true;
    }

    function getDesktopRealLeftItem(index) {
      return getRealItems()[index] || null;
    }

    function getClone(position) {
      return track.querySelector(
        '[data-sb-gw-spirit-clone="' + position + '"]'
      );
    }

    function jumpToRealIndex(index) {
      const target = getDesktopRealLeftItem(index);

      if (!target) return;

      setTrackScrollInstant(getPairScroll(target));
      updateSegments(index);
    }

    function scrollDesktopTo(index, direction) {
      const realItems = getRealItems();
      const realCount = realItems.length;

      if (!desktopLoopReady || realCount <= 3) return;

      const nextIndex =
        ((index % realCount) + realCount) % realCount;

      let visualTarget = getDesktopRealLeftItem(nextIndex);
      let mustNormalize = false;

      if (direction === "previous" && activeIndex === 0) {
        visualTarget = getClone("before-last");
        mustNormalize = true;
      }

      if (
        direction === "next" &&
        activeIndex === realCount - 1
      ) {
        visualTarget = getClone("after-first");
        mustNormalize = true;
      }

      if (!visualTarget) return;

      track.scrollTo({
        left: getPairScroll(visualTarget),
        behavior: "smooth"
      });

      updateSegments(nextIndex);

      if (loopTimer) {
        window.clearTimeout(loopTimer);
      }

      if (mustNormalize) {
        loopTimer = window.setTimeout(function () {
          jumpToRealIndex(nextIndex);
        }, 440);
      }
    }

    function scrollMobileTo(index) {
      const realItems = getRealItems();
      const target = realItems[index];

      if (!target) return;

      track.scrollTo({
        left: getMobileScroll(target),
        behavior: "smooth"
      });

      updateSegments(index);
    }

    function scrollToIndex(index) {
      if (isDesktopLoop()) {
        const realCount = getRealItems().length;
        const normalizedIndex =
          ((index % realCount) + realCount) % realCount;

        const target = getDesktopRealLeftItem(normalizedIndex);

        if (!target) return;

        track.scrollTo({
          left: getPairScroll(target),
          behavior: "smooth"
        });

        updateSegments(normalizedIndex);
      } else {
        scrollMobileTo(index);
      }
    }

    function getClosestVisualItem() {
      const allItems = getAllItems();
      const currentScroll = track.scrollLeft;
      let closestItem = null;
      let smallestDistance = Infinity;

      allItems.forEach(function (item) {
        const targetScroll = isDesktopLoop()
          ? getPairScroll(item)
          : getMobileScroll(item);

        const distance = Math.abs(
          targetScroll - currentScroll
        );

        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestItem = item;
        }
      });

      return closestItem;
    }

    function getActiveIndexFromScroll() {
      const closestItem = getClosestVisualItem();

      if (!closestItem) return 0;

      const itemIndex = parseInt(
        closestItem.getAttribute("data-sb-gw-spirit-index"),
        10
      );

      return Number.isFinite(itemIndex) ? itemIndex : 0;
    }

    function normalizeClonePosition() {
      if (!isDesktopLoop() || !desktopLoopReady) return;

      const closestItem = getClosestVisualItem();

      if (
        closestItem &&
        closestItem.hasAttribute("data-sb-gw-spirit-clone")
      ) {
        jumpToRealIndex(getActiveIndexFromScroll());
      }
    }

    function setupLayout() {
      if (isDesktopLoop()) {
        createClones();
        jumpToRealIndex(activeIndex);
        return;
      }

      removeClones();

      const realItems = getRealItems();
      const target = realItems[activeIndex] || realItems[0];

      if (!target) return;

      setTrackScrollInstant(getMobileScroll(target));
      updateSegments(activeIndex);
    }

    normalizeRealItems();
    setupLayout();

    /* Apparition depuis le bas, décalée de gauche à droite, pour toutes
       les images (statique <= 3 ou carrousel > 3), clones de bord inclus. */
    function initSpiritImageReveal() {
      function revealSpiritGallery() {
        if (gallery.dataset.sbSpiritRevealed === "1") return;
        gallery.dataset.sbSpiritRevealed = "1";
        gallery.classList.add("is-spirit-reveal-visible");

        const items = getAllItems();

        items.forEach(function (item, index) {
          item.classList.add("sb-gw-spirit-image-reveal");
          item.style.setProperty(
            "--sb-gw-spirit-image-reveal-delay",
            String(160 + index * 110) + "ms"
          );
        });

        /* Reflow : applique le décalage avant de lancer la transition. */
        void track.offsetWidth;

        items.forEach(function (item) {
          item.classList.add("is-visible");
        });
      }

      if (
        (reducedMotion && reducedMotion.matches) ||
        !("IntersectionObserver" in window)
      ) {
        revealSpiritGallery();
        return;
      }

      const spiritRevealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            revealSpiritGallery();
            spiritRevealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: "0px 0px -8% 0px"
        }
      );

      spiritRevealObserver.observe(gallery);
    }

    segments.forEach(function (segment, index) {
      segment.addEventListener("click", function () {
        scrollToIndex(index);
      });
    });

    if (previousButton) {
      previousButton.addEventListener("click", function () {
        scrollDesktopTo(activeIndex - 1, "previous");
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        scrollDesktopTo(activeIndex + 1, "next");
      });
    }

    track.addEventListener(
      "scroll",
      function () {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(function () {
          updateSegments(getActiveIndexFromScroll());
        });
      },
      { passive: true }
    );

    if ("onscrollend" in window) {
      track.addEventListener("scrollend", function () {
        normalizeClonePosition();
      });
    }

    let resizeFrame = null;

    window.addEventListener("resize", function () {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(function () {
        setupLayout();
      });
    });

    initSpiritImageReveal();
  });
}